import { Link } from 'react-router-dom'

export default function GlobalFooter () {
    return (
        <footer
            id="global-footer"
            className="global-footer theme-dark"
        >
            <div className="container">
                <div className="row flex-align-items-center flex-justify-content-center flex-justify-content-space-between-md-up">
                    <div className="col display-flex flex-justify-content-center-md-down pad-t-md-down">
                        <a
                            className="global-footer-logo"
                            href="https://www.gse.upenn.edu/about-penn-gse/catalyst"
                            target="_blank"
                            rel="noopener noreferrer"
                            title="Opens in new tab"
                            aria-label="Catalyst @ Penn GSE"
                        >
                            <svg
                                className="logo-catalyst-penn-gse"
                                width="286"
                                height="50"
                            >
                                <use xlinkHref="#logo-catalyst-penn-gse" />
                            </svg>
                        </a>
                    </div>
                    <div className="col-auto col-12-md-down pad-5-t-md-down body-3">
                        <div className="row-condensed flex-align-items-center flex-justify-content-center-md-down">
                            <div className="col-auto">
                                <Link
                                    to="/privacy-terms"
                                >
                                    Privacy & Terms
                                </Link>
                            </div>
                            <div className="col-auto">
                                <p>
                                    Contact:&nbsp;
                                    <a
                                        href="mailto:catapult@gse.upenn.edu"
                                        rel="noopener noreferrer"
                                        target="_blank"
                                        title="Opens in default email client"
                                    >
                                        catapult@gse.upenn.edu
                                    </a>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    )
}
